import { createContext } from 'react';
import { GetTokenSilentlyOptions } from '@auth0/auth0-react';
import { LogLevel } from 'models/LogLevel';
import { ConfigRepo } from 'repos/ConfigRepo';

import { Project } from '../../models/Project';


enum NotificationType {
  Info = 'info',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  Default = 'default',
}

interface AppContextModel {
  getAccessTokenSilently: (options?: GetTokenSilentlyOptions) => Promise<string>;
  configRepo?: ConfigRepo;
  selectedProjectId: number | undefined;
  setSelectedProjectIdAsync: (projectId: number | undefined) => Promise<void>;
  projects: Project[];
  isProjectSelectable: boolean;
  setIsProjectSelectable: (isSelectable: boolean) => void;
  notify: (text: string, type: NotificationType) => void;
  sendLog: (message: string, logLevel: LogLevel, data?: object) => void;
}

/* eslint-disable unused-imports/no-unused-vars */
const defaultAppContext: AppContextModel = {
  getAccessTokenSilently: async (options?: GetTokenSilentlyOptions) => Promise.resolve(''),
  configRepo: new ConfigRepo('test'),
  selectedProjectId: undefined,
  setSelectedProjectIdAsync: (projectId: number | undefined) => Promise.resolve(),
  projects: [],
  isProjectSelectable: true,
  setIsProjectSelectable: (isSelectable: boolean) => {},
  notify: (text: string, type: NotificationType) => {},
  sendLog: (message, logLevel, data) => {},
};
/* eslint-enable unused-imports/no-unused-vars */

const AppContext = createContext<AppContextModel>(defaultAppContext);

export { AppContext, NotificationType };
export type { AppContextModel };
